import {Risorsa} from '../_models/Risorsa';
import {TipoRisorsa} from '../_models/generated/tipo-risorsa';

/**
 * Regola del lancio ordine con «Risorse personali» / «Lavorazioni personali» attive (feature 152).
 * Quando la risorsa (o lavorazione) pianificata non è tra quelle assegnate all'operatore, la scelta
 * di una personale è obbligatoria. Con la lista personale vuota la regola non si applica, per non
 * fermare il lancio a un operatore configurato a metà.
 */
export function richiedeSceltaPersonale(
  codicePianificato: string | null | undefined,
  codiciPersonali: string[],
  filtroAttivo: boolean): boolean {
  if (!filtroAttivo || codiciPersonali.length === 0) {
    return false;
  }
  return !codiciPersonali.includes(codicePianificato ?? '');
}

/** Vero se il codice scelto è accettabile: regola non applicabile oppure codice tra i personali. */
export const codiceValido = (
  codice: string | null | undefined,
  codiciPersonali: string[],
  filtroAttivo: boolean): boolean => !richiedeSceltaPersonale(codice, codiciPersonali, filtroAttivo);

/**
 * Codici delle risorse personali selezionabili al lancio di un ordine di produzione: stesso criterio
 * di `SelectRisorsaComponent` con `tipoRisorsa = PRODUZIONE` (produzione o «tutto»). Le risorse
 * personali di altro tipo (bilance, magazzini…) non contano: non si potrebbero scegliere (analysis A1).
 */
export const codiciRisorseProduzione = (risorse: Risorsa[] | null | undefined): string[] => (risorse ?? [])
  .filter((risorsa: Risorsa) => risorsa.tipoRisorsa === TipoRisorsa.PRODUZIONE || risorsa.tipoRisorsa === TipoRisorsa.TUTTO)
  .map((risorsa: Risorsa) => risorsa.codice);
